const projectsPage = {
    labels: {
      context: 'Context',
      constraints: 'Constraints',
      system: 'System',
      outcome: 'Outcome',
      whyItMatters: 'Why it matters',
      viewRepository: 'View repository'
    },
    eyebrow: 'Case Studies',
    title: 'Experience-first proof for operational backend work.',
    intro:
      'A backend consultant cannot rely on screenshots alone. The useful proof is context, system design, tradeoffs, and the kind of operational problem the work actually solved.',
    commercialAnchor: {
      eyebrow: 'Commercial Anchor',
      title: 'Oponeo.pl',
      summary:
        'Approximately 2.5 years of production backend work in a high-traffic e-commerce and business-systems environment using C#, .NET 6/8, ASP.NET Core, EF Core, SQL Server, Docker, and CI/CD.',
      points: [
        'Built and maintained ASP.NET Core APIs in production conditions',
        'Optimized SQL queries and indexing with repeated evidence of about 25% performance improvement',
        'Worked on payment integrations including Klarna and PayPal',
        'Worked on logistics or order-status integrations such as DPD and GLS',
        'Refactored legacy backend code with SOLID and cleaner architecture habits'
      ]
    },
    themes: [
      {
        title: 'Operational realism',
        description:
          'The strongest work here deals with inventory, reservations, integrations, reporting, and workflows that matter beyond a demo.'
      },
      {
        title: 'Architecture before polish',
        description:
          'The emphasis is on backend shape, data flow, service boundaries, and maintainability rather than shallow feature lists.'
      },
      {
        title: 'Range without identity loss',
        description:
          'The portfolio moves across .NET, Python, automation, and device-aware tooling while keeping the same discipline around structure and clarity.'
      }
    ]
  };

export default projectsPage;
